import * as React from 'react';
import PrintIcon from '../../../../assets/print';
import exportIcon from '../../../../assets/export';
import downarrowIcon from '../../../../assets/downArrow';
import EnhancedTable from 'src/components/TableInvoices';
import BackArrow from '../../../../assets/backArrow';
import './ApplyToOldest.scss';
import OriginalTable from 'src/components/TablesAllInvoices/OriginalTable';
import { Redirect, withRouter, RouteComponentProps } from 'react-router-dom';
import Modal from 'src/components/common/Modal';
import CustomPaginator from 'src/components/common/CustomPaginator';
import NextIcon from '../../../../assets/next';
import OldestInvoice from 'src/components/TablesAllInvoices/OldestTable';
import InvoiceModel from 'src/model/invoice.model';
import invoiceServiceInstance, {
  IFiltersInvoice
} from 'src/services/invoice/InvoiceService';
import CloseIcon from '../../../../assets/close';
import Input from 'src/components/common/Input';
import { Alert } from '@material-ui/lab';
import { IconButton } from '@material-ui/core';
import MatrialCloseIcon from '@material-ui/icons/Close';
import { currencyFormatter } from 'src/utils/currencyFormatter';
import i18n from 'src/translation/i18n';
interface IApplyToOldestProps extends RouteComponentProps {
  totalPages: number;
  pageNumber: number;
  pageSize: number;
  totalCredit: any;
  totalDebit: any;
  handlePagination: (event: any) => void;
  handlePageSizeChange?: (pageSize: number) => void;
  selectedOldestInvoices?: InvoiceModel[];
  getOldestInvoices?: (pagination: any) => void;
  selectedDebit?: number;
  selectedCredit?: number;
  orderNumber: number;
  orderlist: number[];
  invoicelist: number[];
  setSelectedInvoices: (invoices: any) => void;
  transactionId: number[];
  isDisabldBtn: boolean;
  selectCreditInvoices: any;
  getselectCredit: any;
  totalSize: any;
  getCreditDebitSummary: any;
}

const debitErrorMessage = i18n.t('invoices.debitErrorMessage');
const debitErrorMessage2 = i18n.t('invoices.debitErrorMessage2');
class ApplyToOldest extends React.Component<IApplyToOldestProps, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      showdisabledPopup: false,
      creditamount: 0,
      debitamount: 0,
      listOfOrdernumbers: [],
      listOfInvoices: [],
      youPayAmount: 0,
      isDisabldBtn: false,
      input: '',
      signature: '',
      debitCreditErrorMsg: '',
      hideAll: false,
      debitCreditUpdated: true,
      creditPage: 0,
      creditSize: 20,
      selectedCreditDebitInvoices: [],
      oldestIsPending: false,
      creditNoOfPage: 1,
      oldestInvoiceData: [],
      creditInvoiceData: [],
      currentActivePage: 0,
      pageCredit: 0,
      sizeCredit: 100,
      allTableDataArray: [],
      NewCreditInvoiceData: [],
      totalPages: 0,
      totalCredit: 0,
      totalDebit: 0,
      accumulatedDebitAmount: 0,
      totalDebitInvoice: 0
    };
  }

  private handleInput = (value: string) => {
    this.setState({ input: value });
  };
  public arrowBack = () => {
    this.props.history.push('/invoices');
  };
  public clickclose = () => {
    this.setState({ showdisabledPopup: false });
  };
  public getTargetpaymentsData = (listOfInvoices: any) => {
    const appliedCreditInvoices: any[] = [];
    listOfInvoices.forEach((num: any) => {
      // const details = this.props.selectedOldestInvoices.find(
      //   newObj => newObj.invoiceNumber === num
      // );
      appliedCreditInvoices.push({
        orderNumber: num.orderNumber,
        paymentAmount: num.remainingAmount,
        remainingAmount: num.paymentAmount,
        reasonRemainingBalance: '',
        transactionId: num.transactionId
      });
    });
    return appliedCreditInvoices;
  };

  public getTargetPaymentsDataCreditCard = (listOfInvoices: number[]) => {
    const appliedCreditInvoices: any[] = [];
    listOfInvoices.forEach(num => {
      const details = this.props.selectedOldestInvoices.find(
        newObj => newObj.invoiceNumber === num
      );

      appliedCreditInvoices.push({
        customerNumber: details.customerNumber,
        description: details.description,
        dueDate: details.dueDate,
        hasInvoice: details.hasInvoice,
        invoiceDate: details.invoiceDate,
        invoiceNumber: details.invoiceNumber,
        remainingAmount: details.remainingAmount,
        status: details.status,
        orderNumber: details.orderNumber,
        transactionId: details.transactionId
      });
    });
    return appliedCreditInvoices;
  };

  public applyCredits = () => {
    this.setState({ signature: this.state.input }, () => this.clickCredit());
    this.setState({ showdisabledPopup: false });
  };

  public showPopup = () => {
    // if (this.state.debitamount > this.props.totalCredit) {
    //   this.setState({
    //     isDisabldBtn: true,
    //     debitCreditErrorMsg: debitErrorMessage,
    //     debitCreditUpdated: true
    //   });
    // } else
    if (this.props.totalDebit === 0) {
      this.setState({
        debitCreditUpdated: true,
        isDisabldBtn: true,
        debitCreditErrorMsg: i18n.t(
          'invoices.youeitherdonothaveanydebitinvoicesoryouhaveinsufficientcredit'
        )
      });
    } else {
      this.setState({
        isDisabldBtn: false,
        debitCreditErrorMsg: '',
        debitCreditUpdated: true,
        showdisabledPopup: true
      });
    }
  };
  public clickCredit = () => {
    // this.props.history.push('/invoices/applyCredit');
    this.setState({
      oldestIsPending: true
    });
    // const paymentdata = this.getTargetpaymentsData(
    //   this.state.selectedCreditDebitInvoices
    // );
    // let creditSum = 0;
    // paymentdata.forEach(obj => {
    //   creditSum += obj.remainingAmount;
    // });

    const totalCreditUsed =
      this.state.totalDebit < this.state.totalCredit
        ? this.state.totalDebit
        : this.state.totalCredit;

    const creditInfo = {
      signature: this.state.signature,
      totalDebit: this.state.totalDebit,
      totalCredit: this.state.totalCredit,
      creditUsed: totalCreditUsed
    };
    invoiceServiceInstance
      .payInvoicesByCredits([], creditInfo)
      .then((response: any) => {
        this.setState({
          oldestIsPending: false
        });
        this.props.history.push({
          pathname: '/invoices/applyCredit',
          state: {
            orderlist: this.state.selectedCreditDebitInvoices,
            creditUsed: totalCreditUsed,
            totalDebitInvoice: this.state.totalDebitInvoice,
            paymentId: response.data.paymentId,
            page: 'oldest'
          }
        });
      })
      .catch(error => {
        this.setState({
          oldestIsPending: false,
          isDisabldBtn: true,
          debitCreditErrorMsg: error && error.response.data.message
        });
      });
  };

  // }

  public payRemaining = () => {
    if (this.state.listOfInvoices && this.state.listOfInvoices.length > 0) {
      const paymentdata = this.getTargetPaymentsDataCreditCard(
        this.state.listOfInvoices
      );
      this.props.setSelectedInvoices(paymentdata);
      this.props.history.push({
        pathname: '/invoices/payRemaining',
        state: {
          creditAmount: this.props.totalCredit,
          debitAmount: this.state.debitamount,
          creditUsed: this.state.creditUsed,
          youPayAmount: this.state.youPayAmount,
          navigateTo: 'applyOldest'
        }
      });
    } else {
      this.setState({
        debitCreditErrorMsg: debitErrorMessage2
      });
    }
  };
  public checkboxcall = (rowsSelectedpath: any, invoiceData: any) => {
    let newDebitAmount = 0;
    let newCreditAmount = 0;
    const youPayAmount = 0;
    let numberlist: number[] = [];
    let invoicesList: number[] = [];

    rowsSelectedpath.map((index: any) => {
      if (this.props.selectedOldestInvoices.length > 0) {
        // console.log(this.props.selectedOldestInvoices[index].orderNumber);
        numberlist.push(this.props.selectedOldestInvoices[index].orderNumber);
        invoicesList.push(
          this.props.selectedOldestInvoices[index].invoiceNumber
        );
      }
      // if (props.invoiceData.length > 0) {
      const remainingAmount = invoiceData[index].remainingAmount;
      // const pay = newDebitAmount - newDebitAmount

      if (remainingAmount >= 0) {
        newDebitAmount += remainingAmount;
      } else {
        newCreditAmount += remainingAmount;
      }

      // }
    });
    this.setState({
      creditamount: newCreditAmount,
      debitamount: newDebitAmount,
      listOfOrdernumbers: numberlist,
      listOfInvoices: invoicesList,
      youpayAmount: youPayAmount,
      debitCreditUpdated: true
    });
    numberlist = [];
    invoicesList = [];
  };

  public getPreviousInvoice(invoice: any) {
    const invoicesDetailList: any[] = invoice['invoicesDetailList']
      ? invoice['invoicesDetailList']
      : [];
    const previousInvoices: any[] = [];
    if (invoicesDetailList.length > 0) {
      invoicesDetailList.forEach(item =>
        previousInvoices.push(item.previousInvoice)
      );
    }
    return previousInvoices.length > 0
      ? previousInvoices.toString()
      : invoice['previousInvoice'];
  }
  public adjustDebitsAgainstCredits = async () => {
    const creditArr: any = [...this.state.creditInvoiceData];
    const debitArr: any = [...this.state.oldestInvoiceData];
    if (debitArr && debitArr.length > 0 && creditArr && creditArr.length > 0) {
      for (const idx of debitArr) {
        let cumulativeBalance = idx.remainingAmount;
        const mappedCredits = [];
        let creditIndex: any = 0;
        let creditCheck: any = 0;
        let lastCredit = {};
        let index = 0;
        let paymentAmountCtx = 0;
        if (creditArr && creditArr.length > 0) {
          for (const cidx of creditArr) {
            index++;
            if (cumulativeBalance > Math.abs(cidx.remainingAmount)) {
              cumulativeBalance += cidx.remainingAmount;
              paymentAmountCtx += cidx.remainingAmount;
              cidx['paymentAmount'] = cidx.remainingAmount;
              cidx['remainingAmount'] = 0;
              cidx['previousInvoice'] = this.getPreviousInvoice(cidx);
              mappedCredits.push(JSON.parse(JSON.stringify(cidx)));
            } else {
              lastCredit = JSON.parse(JSON.stringify(cidx));
              lastCredit['previousInvoice'] = this.getPreviousInvoice(
                lastCredit
              );
              lastCredit['paymentAmount'] = 0 - cumulativeBalance;
              lastCredit['remainingAmount'] =
                lastCredit['remainingAmount'] + cumulativeBalance;
              mappedCredits.push(lastCredit);
              cidx.remainingAmount += cumulativeBalance;
              paymentAmountCtx += 0 - cumulativeBalance;
              creditIndex = index - 1;
              creditCheck++;
              break;
            }
          }
        }
        idx.mappedCredits = mappedCredits;
        idx.paymentAmount = paymentAmountCtx;
        if (creditCheck === 0) {
          creditArr.splice(0, creditArr.length);
        } else {
          creditArr.splice(0, creditIndex);
        }
      }
    }

    if (
      this.props.totalSize < this.state.creditSize &&
      debitArr &&
      debitArr.length > 0
    ) {
      let indexVal = 0;
      for (let k = 0; k < debitArr.length; k++) {
        if (
          debitArr[k].mappedCredits &&
          debitArr[k].mappedCredits.length === 0
        ) {
          indexVal = k;
          break;
        }
      }
      if (indexVal > 0) {
        debitArr.splice(indexVal, debitArr.length);
        // this.setState({
        //   totalPages: this.state.currentActivePage + 1
        // });
      }
      // if (
      //   (-1 * debitArr[debitArr.length - 1].paymentAmount) / 1 -
      //     debitArr[debitArr.length - 1].remainingAmount <
      //   0
      // ) {
      //   this.setState({
      //     totalPages: this.state.currentActivePage + 1
      //   });
      // }
    }
    this.setState({ selectedCreditDebitInvoices: debitArr }, () => {
      const tempArray = [...this.state.allTableDataArray];
      tempArray.splice(
        this.state.currentActivePage,
        0,
        this.state.selectedCreditDebitInvoices
      );
      const allTableDataArray = tempArray;
      this.setState({
        allTableDataArray,
        NewCreditInvoiceData: creditArr
      });
    });
  };

  // public getSelectedOldestInvoices = () => {
  //   const oldestInvoices = this.props.selectedOldestInvoices;
  //   // this is service to make credit invoices call "this.props.getselectCredit([], {page: 1, size: 50})"
  //   // to access the fetched credit invoices "this.props.selectCreditInvoices"
  //   // Oldest debit invoices "this.props.selectedOldestInvoices"

  //   console.log(this.props.selectCreditInvoices);
  //   // Basath please implement your function here
  //   const val = this.adjustDebitsAgainstCredits(
  //     oldestInvoices,
  //     this.props.selectCreditInvoices
  //   );
  //   console.log(val);
  //   return oldestInvoices;
  // };

  public async componentDidUpdate(prevProps: any, prevState: any) {
    const totalCreditVal = this.props.totalCredit;
    const totalDebitVal = this.props.totalDebit;
    if (
      prevProps.totalDebit !== totalDebitVal ||
      prevProps.totalCredit !== totalCreditVal
    ) {
      // if (
      //   totalDebitVal > 0 &&
      //   totalCreditVal > 0 &&
      //   totalDebitVal > totalCreditVal
      // ) {
      //   this.setState({
      //     hideAll: false,
      //     debitCreditErrorMsg: debitErrorMessage,
      //     debitCreditUpdated: false
      //   });
      // } else
      if (totalDebitVal === 0 && totalCreditVal > 0) {
        this.setState({
          hideAll: true,
          debitCreditErrorMsg: i18n.t(
            'invoices.youeitherdonothaveanydebitinvoicesoryouhaveinsufficientcredit'
          ),
          debitCreditUpdated: false
        });
      } else if (totalCreditVal > 0) {
        this.setState({
          hideAll: false,
          debitCreditErrorMsg: '',
          debitCreditUpdated: false
        });
      }

      this.setState({
        creditamount: totalCreditVal,
        debitamount: totalDebitVal
      });
    }
    if (
      (prevState.creditInvoiceData !== this.state.creditInvoiceData ||
        prevState.oldestInvoiceData !== this.state.oldestInvoiceData) &&
      this.state.creditInvoiceData.length > 0 &&
      this.state.oldestInvoiceData.length > 0
    ) {
      const remainingDebitAmt = this.state.oldestInvoiceData
        .map((data: any) => data.remainingAmount)
        .reduce((a: number, b: number) => a + b, 0);
      const remainingCreditAmt = this.state.creditInvoiceData
        .map((data: any) => data.remainingAmount)
        .reduce((a: number, b: number) => a + b, 0);
      if (remainingDebitAmt <= Math.abs(remainingCreditAmt)) {
        this.adjustDebitsAgainstCredits();
      } else {
        if (this.state.pageCredit / 1 + 1 < this.state.creditNoOfPage) {
          const creditPromise = this.getCreditInvoiceData(
            this.state.pageCredit / 1 + 1,
            this.state.sizeCredit
          );
          creditPromise.then(credits => {
            const combinedCredits = this.state.creditInvoiceData.concat(
              credits
            );
            this.setState({
              creditInvoiceData: combinedCredits,
              oldestIsPending: false
            });
          });
        } else {
          this.adjustDebitsAgainstCredits();
        }
      }
      // this.setState({ oldestIsPending: true });
      // if (
      //   totalDebitVal > 0 &&
      //   Math.abs(totalCreditVal) > 0 &&
      //   totalDebitVal > Math.abs(totalCreditVal) &&
      //   this.props.totalSize > this.state.creditSize
      // ) {
      //   this.props.getselectCredit([], {
      //     page: this.state.creditPage,
      //     size: this.state.creditSize + 100
      //   });
      //   this.setState({ creditSize: this.state.creditSize + 100 });
      // }
      // this.adjustDebitsAgainstCredits().then(() => {
      //   this.setState({ oldestIsPending: false });
      // });
    }
  }

  public getCreditInvoiceData = async (page: any, size: any) => {
    this.setState({
      oldestIsPending: true
    });
    const pagination = { page, size };
    const response: any = await invoiceServiceInstance.selectCredit(
      {},
      pagination
    );
    this.setState({
      creditNoOfPage: response.totalPages,
      pageCredit: response.pageNumber
    });
    return response.data;
  };

  public getOldestInvoiceData = async (
    pageNumbers: number,
    size: number = 20
  ) => {
    this.setState({
      oldestIsPending: true
    });
    const pagination = { page: pageNumbers, size };
    const response: any = await invoiceServiceInstance.oldestInvoice(
      pagination
    );
    return response;
  };

  public newInvoiceData = () => {
    if (
      this.state.allTableDataArray.length - 1 <
      this.state.currentActivePage
    ) {
      const debitPromise = this.getOldestInvoiceData(
        this.state.currentActivePage,
        20
      );
      debitPromise.then(debits => {
        const allowedDebits: any = [];
        let accumulatedDebit = this.state.accumulatedDebitAmount;
        if (this.state.accumulatedDebitAmount < this.state.totalCredit) {
          debits.data.forEach((debit: any) => {
            if (accumulatedDebit < this.state.totalCredit) {
              accumulatedDebit += debit.remainingAmount;
              allowedDebits.push(debit);
            }
          });
        }
        this.setState({
          oldestInvoiceData: allowedDebits,
          creditInvoiceData: this.state.NewCreditInvoiceData,
          oldestIsPending: false
        });
      });
    }
  };

  public changeCurrentPage = (info: any) => {
    if (info === 'next') {
      if (this.state.currentActivePage + 1 < this.state.totalPages) {
        this.setState(
          {
            currentActivePage: this.state.currentActivePage + 1
          },
          () => {
            this.newInvoiceData();
          }
        );
      }
    } else {
      if (this.state.currentActivePage >= 1) {
        this.setState({
          currentActivePage: this.state.currentActivePage - 1
        });
      }
    }
  };

  public componentDidMount() {
    const debitPromise = this.getOldestInvoiceData(
      this.state.currentActivePage,
      20
    );
    const creditPromise = this.getCreditInvoiceData(
      this.state.pageCredit,
      this.state.sizeCredit
    );

    // this.props.getCreditDebitSummary('oldest');
    invoiceServiceInstance
      .creditDebitSummary('oldest')
      .then((response: any) => {
        this.setState({
          totalDebit: response.totalDebit,
          totalCredit: response.totalCredit,
          totalDebitInvoice: response.totalDebitInvoice,
          totalPages: Math.ceil(response.totalDebitInvoice / 20)
        });
        debitPromise.then(debits => {
          const allowedDebits: any = [];
          let accumulatedDebit = this.state.accumulatedDebitAmount;
          if (this.state.accumulatedDebitAmount < this.state.totalCredit) {
            debits.data.forEach((debit: any) => {
              if (accumulatedDebit < this.state.totalCredit) {
                accumulatedDebit += debit.remainingAmount;
                allowedDebits.push(debit);
              }
            });
          }
          creditPromise.then(credits => {
            this.setState({
              oldestInvoiceData: allowedDebits,
              // totalPages: debits.totalPages,
              creditInvoiceData: credits,
              oldestIsPending: false,
              accumulatedDebitAmount: accumulatedDebit
            });
          });
        });
      });

    if (this.props.totalDebit === 0 || this.props.totalCredit === 0) {
      this.setState({
        isDisabldBtn: true
      });
    }
  }
  public render() {
    const youPayAmount =
      this.state.debitamount < this.props.totalCredit
        ? '$0.00'
        : '$' + (this.state.debitamount - this.props.totalCredit).toFixed(2);
    // const totalCreditUsed =
    //   this.state.debitamount < this.props.totalCredit
    //     ? '$' + this.state.debitamount.toFixed(2)
    //     : '$' + this.props.totalCredit.toFixed(2);
    const totalCreditUsed =
      this.state.totalDebit < this.state.totalCredit
        ? currencyFormatter(this.state.totalDebit)
        : currencyFormatter(this.state.totalCredit);
    return (
      <div className="apply-oldest-container">
        <div className="apply-oldest">
          <div className="d-flex ht-0">
            <img
              className="image-icon"
              onClick={this.arrowBack}
              src={BackArrow}
            />
            <div className="apply-heading">
              {i18n.t('invoices.applytoOldest')}
            </div>
          </div>
          <div className="d-flex justify-flex-end">
            {/* <button className="cancel-btn" onClick={this.arrowBack}>
              Cancel
            </button> */}
            {!this.state.hideAll && (
              <button
                className="btn"
                onClick={this.showPopup}
                // disabled={this.state.isDisabldBtn}
              >
                {i18n.t('invoices.applyCredits')}
              </button>
            )}
            {/* <button className="btn" onClick={this.payRemaining}>
              Pay
            </button> */}
          </div>
        </div>
        <div className="d-flex summary-container">
          <div className="d-flex invoices-used">
            <span className="summary">{i18n.t('invoices.summary')}</span>
            <div className="d-flex margin">
              <span className="open-invoices">
                {i18n.t('invoices.totalDebit')}{' '}
              </span>
              <span className="credit-amount1">
                {' '}
                {/* {'$' + this.state.debitamount.toFixed(2)} */}
                {currencyFormatter(this.state.totalDebit)}
              </span>
            </div>

            <div className="d-flex margin">
              <span className="open-invoices">
                {i18n.t('invoices.availableCredit')}{' '}
              </span>
              <span className="credit-amount">
                {' '}
                {/* {'$' + this.props.totalCredit.toFixed(2)} */}
                {currencyFormatter(this.state.totalCredit)}
              </span>
            </div>

            {/* <div className="refresh margin">
              <img className="refresh-icon" src={RefreshIcon} />
              <span className="refresh-label">Reset</span>
            </div> */}
          </div>
          <div className="w-2" />
          <div className="total-pay  d-flex">
            <div className="d-flex credit-used margin">
              <span className="margin-rt">
                {' '}
                {i18n.t('invoices.creditUsed')}{' '}
              </span>
              <span className="credit-amount">{totalCreditUsed}</span>
            </div>
            {/* <div className="margin">
              <span className="margin-rt">You Pay</span>
              <span className="credit-amount">{youPayAmount}</span>
            </div> */}
            {/* <div>
              <img className="next-arrow" src={NextIcon} />
            </div> */}
          </div>
        </div>
        {/* <div className="paginator-container-display">
          <div className="d-flex mb-mt-2 ">
            <div className="img-border">
              <img className="image-icon" src={exportIcon} />
              <img className="down-arrow" src={downarrowIcon} />
            </div>
            <div className="border-bt-tp  border-rad">
              <img className="image-icon" src={PrintIcon} />
            </div>
          </div>
          <div className="rp-product-status--paginator">
            <CustomPaginator
              activePage={1}
              totalPages={20}
              itemsPerPage={5}
              onPageChanged={this.props.handlePagination}
              totalItems={300}
              showPageInfo={true}
              onPageSizeChange={this.props.handlePageSizeChange}
              showPageRangeChange={true}
              currentPageSize={1}
            />
          </div>
        </div> */}
        {this.state.debitCreditErrorMsg &&
          this.state.debitCreditErrorMsg.length > 0 && (
            <>
              <Alert
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                      this.setState({ debitCreditErrorMsg: '' });
                    }}
                  >
                    <MatrialCloseIcon fontSize="inherit" />
                  </IconButton>
                }
                severity="error"
              >
                {this.state.debitCreditErrorMsg}
              </Alert>
              <br />
              <br />
            </>
          )}

        <div>
          <OldestInvoice
            currentActivePage={this.state.currentActivePage}
            changeCurrentPage={this.changeCurrentPage}
            totalPages={this.state.totalPages}
            invoiceData={
              this.state.allTableDataArray[this.state.currentActivePage]
            }
            isChecked={this.checkboxcall}
            hideAll={this.state.hideAll}
            oldestIsPending={this.state.oldestIsPending}
          />
        </div>
        {this.state.showdisabledPopup ? (
          <div>
            <Modal handleCloseModal={() => console.log('Modal closed')}>
              <div className="apply-original-modal">
                <div className="d-flex justify-space-bw">
                  <div className="modal-label">
                    <b>{i18n.t('invoices.applyingCredit')}</b>
                  </div>
                  <div className="close-icon" onClick={this.clickclose}>
                    <img src={CloseIcon} />
                  </div>
                </div>
                <div className="modal-content">
                  {i18n.t('invoices.toPay')} {totalCreditUsed}{' '}
                  {i18n.t(
                    'invoices.usingyourcredityoumustprovideyoursignature'
                  )}
                </div>
                <Input
                  label={i18n.t('invoices.enteryourFullName')}
                  onChange={this.handleInput}
                  value={this.state.input}
                  className="rp-forgotpassword--input"
                />
                <div className="text-align-center">
                  <button className="ok-btn mr-20" onClick={this.clickclose}>
                    {i18n.t('common.cancel')}
                  </button>
                  <button className="ok-btn" onClick={this.applyCredits}>
                    {i18n.t('common.continueActionTxt')}
                  </button>
                </div>
              </div>
            </Modal>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default ApplyToOldest;
